import { Crop, Field, Parcel } from 'src/app/common/_models';

export enum ActivitiesDataStatus {
  COMPLETED = 'COMPLETED',
  PARTIAL = 'PARTIAL',
  MISSING = 'MISSING',
  NOTEXECUTED = 'NOTEXECUTED',
}

export enum ActivitiesGroupType {
  SEEDING = 'seeding',
  FEEDING = 'feeding',
  HARVESTING = 'harvesting',
  DEFENDING = 'defending',
  GROUND_PROCESSING = 'ground_processing',
}

export enum ColumnsActivitiesDetailsTable {
  ACTIVITY_DATE = 'activity_date',
  YIELD = 'yield',
  RESIDUALS = 'residuals',
  PRODUCT_NAME = 'product_name',
  PRODUCT_DOSE = 'product_dose',
  PRODUCT_DOSE_UNIT = 'product_dose_unit',
  SPECIFIC_ACTIVITY_TYPE = 'specific_activity_type',
  STATUS = 'status',
  ACTIONS = 'actions',
}

export class ActivityGroupDataStatus {
  [ActivitiesGroupType.SEEDING]: string = null;
  [ActivitiesGroupType.FEEDING]: string = null;
  [ActivitiesGroupType.HARVESTING]: string = null;
  [ActivitiesGroupType.DEFENDING]: string = null;
  [ActivitiesGroupType.GROUND_PROCESSING]: string = null;
}

export class ActivityGroupDataScore {
  [ActivitiesGroupType.SEEDING]: number = null;
  [ActivitiesGroupType.FEEDING]: number = null;
  [ActivitiesGroupType.HARVESTING]: number = null;
  [ActivitiesGroupType.DEFENDING]: number = null;
  [ActivitiesGroupType.GROUND_PROCESSING]: number = null;
}
export class SingleActivityDataStatus {
  activityId: number = null;
  field: Field = null;
  crop: Crop = null;
  dataStatus: number = null;
  activityGroupType: string = null;
  metadata?: any = null;
}

export class SingleCropActivityDataScore {
  field: Field = null;
  crop: Crop = null;
  parcel: Parcel = null;
  seeding: number = 0;
  feeding: number = 0;
  harvesting: number = 0;
  defending: number = 0;
  ground_processing: number = 0;
}

export class SingleCropActivityDataStatus {
  crop: Crop = null;
  activitiesGroupDStatus: ActivityGroupDataStatus = new ActivityGroupDataStatus();
}

export class SinglePlotActivityDataStatus {
  // Todo make id mandatory
  id?: number = null;
  field: Field = null;
  parcel: Parcel = null;
  crops: SingleCropActivityDataStatus[] = [new SingleCropActivityDataStatus()];
  plotActivitiesDStatus: ActivityGroupDataStatus = new ActivityGroupDataStatus();
  plotSummaryDStatus: string = null;
}

interface ActivityDeclaration {
  groupType: ActivitiesGroupType;
  notExecution: boolean;
}

export class CropActivityDeclaration {
  id?: number = null; // id of the declaration object is created in the BE
  fieldId: number = null;
  parcelId: number = null;
  cropId: number = null;
  activityDeclarations: ActivityDeclaration[] = Object.values(ActivitiesGroupType).map(
    (groupType) => ({
      groupType,
      notExecution: false,
    })
  );
  touched?: boolean = false; // Flag to indicate if the crop declaration has been touched
}

export interface ActivitiesTableFilters {
  dataStatus: { id: string; itemName: string }[];
  sectionName: string;
}

//* List of activities type for the Regenerative divided by group

//* Shared Seeding & Defense
const RegenerativeSeedingAndDefendingActivities: string[] = [
  'seeding_defending',
  'seeding_defending_direct_seeding',
  'seeding_defending_dry_seeding',
  'seeding_defending_submerged_seeding',
  'seeding_defending_standard_seeding',
];

//* Shared Seeding & Fertilization
const RegenerativeSeedingAndFeedingActivities: string[] = [
  'seeding_feeding',
  'seeding_feeding_direct_seeding',
  'seeding_feeding_dry_seeding',
  'seeding_feeding_submerged_seeding',
  'seeding_feeding_standard_seeding',
];

//* Shared Seeding & Soil Processing
const RegenerativeSeedingAndGroundProcessingActivities: string[] = [
  'seeding_harrowing',
  'seeding_harrowing_dry_seeding',
  'seeding_harrowing_submerged_seeding',
  'seeding_harrowing_standard_seeding',
];

//* Shared Seeding & Defense & Fertilization
const RegenerativeSeedingDefendingAndFeedingActivities: string[] = [
  'defending_feeding_seeding',
  'defending_feeding_seeding_direct_seeding',
  'defending_feeding_seeding_dry_seeding',
  'defending_feeding_seeding_submerged_seeding',
  'defending_feeding_seeding_standard_seeding',
];

//* Shared Defense & Fertilization
const RegenerativeDefendingAndFeedingActivities: string[] = [
  'defending_feeding',
  'defending_feeding_transplantation',
];

//* Shared Fertilization & Soil Processing
const RegenerativeFeedingAndGroundProcessingActivities: string[] = [
  'weeding_feeding',
  'tamping_feeding',
];

//* Seeding, Feeding, Harvesting, Defending, Ground Processing
export const RegenerativeSeedingActivities: string[] = [
  'seeding',
  'direct_seeding',
  'dry_seeding',
  'standard_seeding',
  'submerged_seeding',
  ...RegenerativeSeedingAndDefendingActivities,
  ...RegenerativeSeedingAndFeedingActivities,
  ...RegenerativeSeedingAndGroundProcessingActivities,
  ...RegenerativeSeedingDefendingAndFeedingActivities,
];

export const RegenerativeHarvestingActivities: string[] = ['harvesting'];

export const RegenerativeDefendingActivities: string[] = [
  'defending',
  ...RegenerativeSeedingAndDefendingActivities,
  ...RegenerativeSeedingDefendingAndFeedingActivities,
  ...RegenerativeDefendingAndFeedingActivities,
];

export const RegenerativeFeedingActivities: string[] = [
  'feeding',
  'transplantation_feeding',
  ...RegenerativeSeedingAndFeedingActivities,
  ...RegenerativeSeedingDefendingAndFeedingActivities,
  ...RegenerativeDefendingAndFeedingActivities,
  ...RegenerativeFeedingAndGroundProcessingActivities,
];

export const RegenerativeGroundProcessingActivities: string[] = [
  'harrowing',
  'tilling',
  'deep_plowing',
  'tillage',
  'drilling',
  'leveling',
  'milling',
  'minimum_tillage',
  'rolling',
  'soil_ripping',
  'ground_processing',
  'slicing',
  'laser_leveling',
  'tamping',
  'ridging',
  'weeding',
  'convexing',
  'false_sowing',
  'green_manure',
  'strip_till',
  ...RegenerativeSeedingAndGroundProcessingActivities,
  ...RegenerativeFeedingAndGroundProcessingActivities,
];
